module.exports = __webpack_public_path__ + "img/roadmap-phase-3-cell-1-icon.f2977738.svg";